import React from 'react';
import { Redirect } from 'react-router-dom';
import { Location } from 'history';
import {
	AcceptInvite,
	ChangeMfaMethod,
	ChangePassword,
	ForgotPassword,
	ForgotPasswordSubmit,
	NoMatch,
	SignIn,
	Version,
} from '@/pages';

import { HeaderNoAuth } from '@/components';

type RouteConfig = {
	path: string;
	exact: boolean;
	private: boolean;
	header: () => JSX.Element | null;
	main: React.ComponentType<{ location?: Location }>;
};

export const routes: RouteConfig[] = [
	{
		path: '/',
		exact: true,
		private: false,
		header: () => null,
		main: ({ location }) => (
			<Redirect to={{ pathname: '/sign-in', search: location?.search || '', state: location?.state }} />
		),
	},
	{
		path: '/sign-in',
		exact: true,
		private: false,
		header: () => null,
		main: SignIn,
	},
	{
		path: '/forgot-password',
		exact: true,
		private: false,
		header: HeaderNoAuth,
		main: ForgotPassword,
	},
	{
		path: '/forgot-password-submit',
		exact: true,
		private: false,
		header: HeaderNoAuth,
		main: ForgotPasswordSubmit,
	},
	{
		path: '/change-mfa-method',
		exact: true,
		private: true,
		header: HeaderNoAuth,
		main: ChangeMfaMethod,
	},
	{
		path: '/accept-invite/:inviteId',
		exact: true,
		private: false,
		header: HeaderNoAuth,
		main: AcceptInvite,
	},
	{
		path: '/change-password',
		exact: true,
		private: true,
		header: HeaderNoAuth,
		main: ChangePassword,
	},
	{
		path: '/version',
		exact: true,
		private: false,
		header: HeaderNoAuth,
		main: Version,
	},
	{
		path: '*',
		exact: false,
		private: false,
		header: HeaderNoAuth,
		main: NoMatch,
	},
];
